module.exports = __webpack_public_path__ + "assets/img/pay-guide-android.41270e86.png";